import React, { useEffect, useState } from 'react';
import axios from 'axios';

/* Location picker (2026-10-20). Locations are managed by advanced users under
   Sites → Locations. For users the value is the location NAME (the database links
   it to the managed location and the user's extensions follow); for numbers (DIDs)
   pass byId and the value is the location id. */
let cache: Promise<any[]> | null = null;
export function loadLocations(force = false): Promise<any[]> {
  if (!cache || force) cache = axios.get('/api/locations').then((r) => (Array.isArray(r.data) ? r.data : [])).catch(() => []);
  return cache;
}

type Props = { value: any; onChange: (v: any, loc?: any) => void; byId?: boolean; siteId?: any; style?: any; className?: string; placeholder?: string; disabled?: boolean };
export default function LocationSelect({ value, onChange, byId, siteId, style, className, placeholder, disabled }: Props) {
  const [locs, setLocs] = useState<any[]>([]);
  useEffect(() => { let on = true; loadLocations().then((l) => on && setLocs(l)); return () => { on = false; }; }, []);
  const active = locs.filter((l) => Number(l.is_active) || (byId ? Number(l.id) === Number(value) : String(l.name).toLowerCase() === String(value || '').trim().toLowerCase()));
  const list = siteId ? active.filter((l) => !l.site_id || Number(l.site_id) === Number(siteId)) : active;
  const match = byId ? list.find((l) => Number(l.id) === Number(value)) : list.find((l) => String(l.name).toLowerCase() === String(value || '').trim().toLowerCase());
  const legacy = !byId && value && !match ? String(value) : '';
  const sites = Array.from(new Set(list.map((l) => l.site_name || 'Other')));
  return (
    <select className={className} style={style} disabled={disabled}
      value={byId ? (match ? String(match.id) : '') : (match ? match.name : legacy)}
      onChange={(e) => {
        const v = e.target.value;
        const loc = byId ? list.find((l) => String(l.id) === v) : list.find((l) => l.name === v);
        onChange(byId ? (v ? Number(v) : null) : v, loc);
      }}>
      <option value="">{placeholder || '— location not set —'}</option>
      {legacy && <option value={legacy}>{legacy} (old text — please choose a location)</option>}
      {sites.map((s) => (
        <optgroup key={s} label={s}>
          {list.filter((l) => (l.site_name || 'Other') === s).map((l) => <option key={l.id} value={byId ? String(l.id) : l.name}>{l.name}</option>)}
        </optgroup>))}
    </select>);
}
